<!-- Page Paramètres de diffusions -->
<div class="private-campaign" [style.display]="loaded ? '' : 'none'">
    <button class="mainGoBackBtn" mat-flat-button outlined (click)="goBack()">
        <mat-icon> arrow_back_ios </mat-icon>
        Précédent
    </button>
    <h1 class="title">Modifier les paramètres de diffusion</h1>

    <div class="diffParamCard">
        <!-- Nom de la diffusion -->
        <h2 class="diffTitle">Diffusion {{ controls.name.value }}</h2>

        <div class="selection-cards">
            <!-- MARK: Dates de diffusion -->
            <div class="paramLineContainer">
                <div class="mainDiffParamLine">
                    <p class="title">Dates de diffusion</p>
                    <mat-form-field appearance="outline" class="periodFormField gradiantFormField">
                        <mat-select
                            [(ngModel)]="indexSelected"
                            (selectionChange)="setEndDate($event.value); indexSelected = $event.value"
                        >
                            <mat-select-trigger class="inlineTrigger">
                                <mat-icon color="primary">{{ getCardIcon(indexSelected) }}</mat-icon>
                                <b>{{ PeriodTypeTranslate[PerdiodTypeEnum[indexSelected]] }}</b>
                            </mat-select-trigger>
                            @for (typeEnum of PerdiodTypeEnum | enumToArray; track $index) {
                                @if ((isWancomDiff && $index !== 1 && $index !== 3) || !isWancomDiff) {
                                    @if ((isWancomDiff && $index !== 0 && isTodayNotInDates()) || !isWancomDiff) {
                                        <mat-option [value]="$index">
                                            <mat-icon color="primary" class="cardIcon">{{
                                                getCardIcon($index)
                                            }}</mat-icon>
                                            {{ PeriodTypeTranslate[PerdiodTypeEnum[$index]] }}
                                        </mat-option>
                                    }
                                }
                            }
                        </mat-select>
                        <mat-icon color="primary" matSuffix>arrow_back_ios</mat-icon>
                    </mat-form-field>

                    @switch (indexSelected) {
                        @case (1) {
                            <!-- Aujourd'hui -->
                            <span class="info">
                                Jusqu'au
                                {{
                                    date.plus({
                                        days: dayUntillWeekEnd,
                                    }) | date: 'dd/MM/yyyy'
                                }}
                            </span>
                        }
                        @case (2) {
                            <!-- Sélection Autre -->
                            <span class="moreTxt">Choisissez une date</span>
                            <mat-form-field appearance="outline" class="campaignDateField gradiantFormField">
                                <mat-date-range-input
                                    [min]="startReservation ?? today"
                                    [max]="endReservation"
                                    [rangePicker]="picker"
                                >
                                    <input
                                        matStartDate
                                        [(ngModel)]="controls.beginDate.value"
                                        placeholder="Date de début"
                                    />
                                    <input matEndDate [(ngModel)]="controls.endDate.value" placeholder="Date de fin" />
                                </mat-date-range-input>
                                <mat-datepicker-toggle
                                    color="primary"
                                    matIconSuffix
                                    [for]="picker"
                                    
                                ></mat-datepicker-toggle>
                                <mat-date-range-picker [touchUi]="!isDeviceisDesktop" #picker></mat-date-range-picker>
                            </mat-form-field>
                        }
                        @case (3) {
                            <!-- Date de départ diffusion permanente -->
                            <div class="inline-content">
                                <p>À partir du</p>
                                <mat-form-field appearance="outline">
                                    <input
                                        [formControl]="controls.beginDate"
                                        matInput
                                        [matDatepicker]="startPicker"
                                        placeholder="Date de début"
                                    />
                                    <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startPicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        }
                        @default {
                            <span class="info">
                                Jusqu'au
                                {{
                                    date.plus({
                                        days: PeriodTypeCalculationDate[PerdiodTypeEnum[0]],
                                    }) | date: 'dd/MM/yyyy'
                                }}
                            </span>
                        }
                    }
                </div>
            </div>

            @if (isStaticSpot) {
                <div class="paramLineContainer">
                    <div class="mainDiffParamLine">
                        <p class="title">Durée d'affichage</p>
                        <mat-form-field appearance="outline" class="gradiantFormField">
                            <mat-select [formControl]="controls.spotDuration">
                                <mat-option [value]="10" > 10 secondes </mat-option>
                                <mat-option [value]="20"> 20 secondes </mat-option>
                                <mat-option [value]="30"> 30 secondes </mat-option>
                                <mat-option [value]="40"> 40 secondes </mat-option>
                                <mat-option [value]="50"> 50 secondes </mat-option>
                                <mat-option [value]="60"> 1 minute </mat-option>
                            </mat-select>
                            <mat-icon color="primary" matSuffix>arrow_back_ios</mat-icon>
                        </mat-form-field>
                    </div>
                </div>
            }

            <!-- Options de diffusions (Aujourd'hui, cette Semaine, ...) -->
            <div style="display: none" class="flex-cards">
                @for (typeEnum of PerdiodTypeEnum | enumToArray; track $index) {
                    @if ((isWancomDiff && $index !== 1 && $index !== 3) || !isWancomDiff) {
                        @if ((isWancomDiff && $index !== 0 && isTodayNotInDates()) || !isWancomDiff) {
                            <!-- Card du choix de diffusion -->
                            <div
                                class="contact-card"
                                (click)="setEndDate($index); indexSelected = $index"
                                [ngClass]="indexSelected === $index ? 'selected' : ''"
                            >
                                <mat-icon class="cardIcon">{{ getCardIcon($index) }}</mat-icon>
                                <span class="cardTitle">
                                    {{ PeriodTypeTranslate[PerdiodTypeEnum[$index]] }}
                                </span>
                            </div>
                        }
                    }
                }
            </div>

            @if (isWancomDiff) {
            <div class="paramLineContainer">

                    <div class="mainDiffParamLine">
                        <p class="title">
                            Ordre de priorité
                            <button mat-icon-button color="primary"><mat-icon>help</mat-icon></button>
                        </p>
                        <div class="prioritySelect">
                            <article
                                (click)="controls.diffusionPriority.setValue(0)"
                                matRipple
                                class="priorityBtn low"
                                [ngClass]="{ selected: controls.diffusionPriority.value === 0 }"
                            >
                                <mat-icon>keyboard_double_arrow_down</mat-icon>
                                Basse
                            </article>

                            <article
                                (click)="controls.diffusionPriority.setValue(1)"
                                matRipple
                                class="priorityBtn mid"
                                [ngClass]="{ selected: controls.diffusionPriority.value === 1 }"
                            >
                                <mat-icon svgIcon="airware"></mat-icon>
                                Moyenne
                            </article>

                            <article
                                (click)="controls.diffusionPriority.setValue(2)"
                                matRipple
                                class="priorityBtn high"
                                [ngClass]="{ selected: controls.diffusionPriority.value === 2 }"
                            >
                                <mat-icon>keyboard_double_arrow_up</mat-icon>
                                Haute
                            </article>
                            <br />
                            @if (
                                controls.diffusionPriority.hasError('required') && controls.diffusionPriority.touched
                            ) {
                                <mat-error>Un ordre de priorité est <b>requis</b></mat-error>
                            }
                        </div>
                    </div>
                </div>
            }

            <div class="paramLineContainer">
                <div class="mainDiffParamLine">
                    <p class="title">
                        Seul dans la boucle
                        <button
                        (click)="isDeviceisDesktop ? '' : seulTooltip.toggle();"
                            mat-icon-button
                            color="primary"
                            #seulTooltip="matTooltip"
                            [matTooltipClass]="'customtooltip'"
                            matTooltip="Votre spot sera diffusé à la place de tous les autres durant ses périodes de diffusion"
                        >
                            <mat-icon>help</mat-icon>
                        </button>
                    </p>

                    <mat-slide-toggle color="primary" [formControl]="controls.loopOverride">
                        {{ controls.loopOverride.value ? 'Oui' : 'Non' }}
                    </mat-slide-toggle>
                </div>
            </div>
        </div>

        <hr />

        <h2 class="subTitle">Options de diffusion</h2>

        <!-- Paramètres de diffusion Globaux -->
        <wncm-form-control-diffusion-settings
            [indexSelected]="indexSelected"
            #diffusionSettings
            [weekDaysControl]="controls.weekDays"
            [beginHourControl]="controls.beginHour"
            [endHourControl]="controls.endHour"
            [weatherControl]="controls.weather"
            [minTempControl]="controls.minTemp"
            [maxTempControl]="controls.maxTemp"
        ></wncm-form-control-diffusion-settings>
        <button [disabled]="!loaded" class="validBtn" mat-fab extended color="primary" (click)="nextTo(editMode)">
            Valider la diffusion
        </button>
    </div>
</div>

@if (!loaded) {
    <mat-spinner style="margin: auto; margin-top: 50px"></mat-spinner>
}
